import * as Yup from "yup";

/**
 * Validation schema rule for device group
 */
export const DeviceGroupSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .label("Device group name")
    .required()
    .nullable()
    .max("100"),
  devices: Yup.array()
    .of(Yup.string())
    .label("Devices")
    .required()
    .nullable()
    .min(1, "Please select at least one device"),
});
